import React, { type SyntheticEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import ChevronDownIconLegacy from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIconLegacy from '@atlaskit/icon/glyph/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/utility/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/utility/chevron-up';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { TContentSectionExpanderProps } from '../../../../common/types.tsx';
import messages from './messages.tsx';

const ContentSectionExpander = ({
	isContentExpanded,
	onExpand,
	onCollapse,
}: TContentSectionExpanderProps) => {
	const handleExpand = (event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		onExpand();
		fireUIAnalytics(analyticsEvent, 'showSimilarIncidents', {
			similarIncidentsPanel: true,
		});
	};

	const handleCollapse = (event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		onCollapse();
		fireUIAnalytics(analyticsEvent, 'hideSimilarIncidents');
	};

	const { formatMessage } = useIntl();

	const renderShowIssuesButton = () => (
		<IconButton
			label={formatMessage(messages.show)}
			appearance="subtle"
			data-testId="smart-related-issues-panel.ui.similar-incidents.header.expander.expand-button"
			icon={(props) => (
				<ChevronDownIcon
					{...props}
					color="currentColor"
					LEGACY_size="large"
					label="ChevronDownIcon"
					LEGACY_fallbackIcon={ChevronDownIconLegacy}
				/>
			)}
			onClick={handleExpand}
			interactionName="auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.header.expander.button"
		/>
	);

	const renderHideIssuesButton = () => (
		<IconButton
			label={formatMessage(messages.hide)}
			appearance="subtle"
			data-test-id="smart-related-issues-panel.ui.similar-incidents.header.expander.collapse-button"
			icon={(props) => (
				<ChevronUpIcon
					{...props}
					color="currentColor"
					LEGACY_size="large"
					label="ChevronUpIcon"
					LEGACY_fallbackIcon={ChevronUpIconLegacy}
				/>
			)}
			onClick={handleCollapse}
			interactionName="auto-generated.jira-smart-related-issues-panel.ui.similar-incidents.header.expander.button1"
		/>
	);

	return isContentExpanded ? renderHideIssuesButton() : renderShowIssuesButton();
};

export default ContentSectionExpander;
